import "./Modal.scss";
import { createPortal } from "react-dom";
import { ModalXIcon } from "../../../assets/icons";
import { isValidElement, useEffect, useRef, useState } from "react";
import { LeftArrow } from "../../../assets/icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Modal = ({
  open,
  title,
  style,
  footer,
  goBack,
  domNode,
  onCancel,
  children,
  getZIndex,
  afterClose,
  mask = true,
  customHeader,
  wrapperStyle,
  className = "",
  afterOpenChange,
  keyboard = true,
  closable = true,
  fullScreen = false,
  wrapClassName = "",
  headerExtrasLeft = null,
  headerExtrasRight = null,
  maskClosable = false,
  destroyOnClose = false,
}) => {
  const goBackBtn = (fullScreen && goBack) || goBack;
  const navigate = useNavigate();

  const { isDarkMode } = useSelector((state) => state.usersList);

  const modalRef = useRef(null);

  const [openModal, setOpenModal] = useState(open);

  const handleOnCancel = (maskClick) => {
    if (maskClick) {
      if (maskClosable && typeof onCancel === "function") {
        onCancel();
      }
    } else if (typeof onCancel === "function") {
      onCancel();
    }

    !!afterClose && typeof afterClose === "function" && afterClose();
  };

  const handleKeyDown = (e) => {
    if (keyboard && e.key === "Escape") {
      handleOnCancel();
    }
  };
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    const otherAntModals = document.querySelectorAll(".ant-modal-wrap");
    const otherCustomModals = document.querySelectorAll(".modalWrapper");

    const maxZindex = Math.max(
      ...Array.from([...otherAntModals, ...otherCustomModals]).map((modal) => {
        const zIndex = window.getComputedStyle(modal).zIndex;
        return parseInt(zIndex, 10) || 0;
      })
    );
    modalRef.current.style.zIndex = maxZindex + 200;
    if (!!getZIndex && typeof getZIndex === "function") {
      getZIndex(maxZindex + 200);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (open) {
      setOpenModal(true);
    } else {
      const timer = setTimeout(() => setOpenModal(false), 300);
      return () => clearTimeout(timer);
    }
    if (!!afterOpenChange && typeof afterOpenChange === "function") {
      afterOpenChange(modalRef.current);
    }
  }, [open, afterOpenChange]);

  if (destroyOnClose && !openModal) return null;

  return createPortal(
    <div
      ref={modalRef}
      style={wrapperStyle}
      className={`modalWrapper ${
        isDarkMode ? "dark darkHeader" : "lightHeader"
      } ${!destroyOnClose && !openModal ? "hideModal" : ""} ${wrapClassName}`}
    >
      {!!mask ? (
        <div className="modalBackdrop" onClick={() => handleOnCancel(true)} />
      ) : null}
      <div
        style={style}
        className={`modalContent ${
          fullScreen ? "fullScreen" : ""
        } ${className}`}
      >
        {!!customHeader ? (
          customHeader
        ) : (
          <div className="modalHeader">
            {!!fullScreen && !!goBackBtn ? (
              isValidElement(goBackBtn) ? (
                goBackBtn
              ) : (
                <span
                  className="modalBackButton"
                  onClick={
                    typeof goBackBtn === "function"
                      ? goBackBtn
                      : () => navigate(-1)
                  }
                >
                  <LeftArrow fill={isDarkMode ? "#fbfbfb" : "#231f20"} />
                </span>
              )
            ) : null}
            <div
              className="modalTitle"
              style={
                headerExtrasRight ? { justifyContent: "space-between" } : {}
              }
            >
              {title}
              {!!headerExtrasLeft ? (
                <span className="headerDivider"></span>
              ) : null}
              <div className="modalHeaderExtras">
                {headerExtrasLeft || headerExtrasRight}
              </div>
            </div>
            {!!closable ? (
              <div
                className="modalClose"
                data-testid="modalClose"
                onClick={() => handleOnCancel()}
              >
                <ModalXIcon fill={isDarkMode ? "#F4F5F6" : "#231f20"} />
              </div>
            ) : null}
          </div>
        )}
        {fullScreen ? <span className="fullScreenDivider"></span> : null}
        <div className="modalBody">{children}</div>
        {!!footer ? <div className="modalFooter">{footer}</div> : null}
      </div>
    </div>,
    domNode || document.body
  );
};

export default Modal;
